const miscEvents = {
    events: [
    {
        "id": 1,
        "year": 1818,
        "event": "The White House officially reopens, four years after the British burned it during the War of 1812."
    },
    {
        "id": 2,
        "year": 1818,
        "event": "The story Frankenstein is written by Mary Shelley and published anonymously."
    },
    {
        "id": 3,
        "year": 1818,
        "event": "Fugitive slaves and Native Americans in Florida fight General Andrew Jackson and the U.S. Army in the First Seminole War."
    },
    {
        "id": 4,
        "year": 1818,
        "event": "The Treaty of 1818 between the U.S. and the United Kingdom establishes most of the border between the United States and Canada. "
    },
    {
        "id": 5,
        "year": 1820,
        "event": "The Missouri Compromise allows the new state of Missouri to hold slaves, and the new state of Maine to be free."
    },
    {
        "id": 6,
        "year": 1820,
        "event": "South Carolina outlaws making or owning anti-slavery materials and forces enslaved people to wear special ID tags."
    },
    {
        "id": 7,
        "year": 1820,
        "event": "Colonel Robert Gibbon Johnson proves that tomatoes are not poisonous by eating one in public on September 28, 1820."
    },
    {
        "id": 8,
        "year": 1820,
        "event": "On November 20, 1820, the Nantucket, MA, whaling ship Essex sinks after being attacked by a sperm whale. The event inspires Herman Melville's 1851 novel, Moby Dick."
    },
    {
        "id": 9,
        "year": 1826,
        "event": "Former U.S. presidents John Adams and Thomas Jefferson both die on the 4th of July, 50 years after signing the Declaration of Independence. "
    },
    {
        "id": 10,
        "year": 1826,
        "event": "Pennsylvania protects free Blacks by passing an anti-kidnapping law."
    },
    {
        "id": 11,
        "year": 1826,
        "event": "Sarah Parker Remond is born. She later becomes an anti-slavery lecturer whose speeches help keep England from entering the Civil War on the side of the Confederacy."
    },
    {
        "id": 12,
        "year": 1826,
        "event": "Maryland Assembly passes the \"Jew Bill,\" removing restrictions that prevented Jews from holding public office."
    },
    {
        "id": 13,
        "year": 1829,
        "event": "The Oblate Sisters of Providence, the first permanent order of black Catholic nuns, is founded in Baltimore, Maryland."
    },
    {
        "id": 14,
        "year": 1829,
        "event": "Louis Braille publishes his first book for the blind. The Braille writing system uses a series of one to six raised dots to make characters that are felt with the fingertips by people who are visually impaired, blind, or have low vision. "
    },
    {
        "id": 15,
        "year": 1829,
        "event": "The Smithsonian Institution was established with funds gifted to the United States after the death of British scientist James Smithson. "
    },
    {
        "id": 16,
        "year": 1829,
        "event": "Andrew Jackson is inaugurated as the seventh President of the United States. He replaced John Quincy Adams after his only term in office."
    },
    {
        "id": 17,
        "year": 1830,
        "event": "Hezekiah Grice, a Baltimore activist, writes to African American leaders to create a plan for Black families to move to Canada. The first National Negro Convention is held in Philadelphia to address the issue."
    },
    {
        "id": 18,
        "year": 1830,
        "event": "Peter Cooper developed and built a small coal-burning steam locomotive to prove that the train could be successful on the Baltimore and Ohio Railroad."
    },
    {
        "id": 19,
        "year": 1830,
        "event": "William L. Sublette took the first wagons along the Oregon Trail to the Rocky Mountains with goods and supplies. The supply caravan traveled from Independence, Missouri to Oregon City, Oregon. "
    },
    {
        "id": 20,
        "year": 1830,
        "event": "The United States continues to expand as its population increases. The center of US population is located in Moorefield, West VIrginia. "
    },
    {
        "id": 21,
        "year": 1831,
        "event": "William Lloyd Garrison of Boston, Massachusetts publishes The Liberator, the foremost abolitionist newspaper."
    },
    {
        "id": 22,
        "year": 1831,
        "event": "Baltimore & Ohio Railroad Station at Ellicott's Mills, Maryland is the first railroad terminal constructed in the nation."
    },
    {
        "id": 23,
        "year": 1831,
        "event": "After his presidency, John Quincy Adams is elected as an anti-slavery congressman from Massachusetts. He is the only ex-president to serve in Congress, serving from 1831 - 1848. "
    },
    {
        "id": 24,
        "year": 1831,
        "event": "North Carolina passes a law that makes it illegal to teach enslaved people how to read and write. "
    },
    {
        "id": 25,
        "year": 1833,
        "event": "The American Anti-Slavery Society is established in Philadelphia, Pennsylvania under the leadership of William Lloyd Garrison."
    },
    {
        "id": 26,
        "year": 1833,
        "event": "Oberlin College is founded in Ohio and becomes the first college to offer education to whites and Blacks together."
    },
    {
        "id": 27,
        "year": 1833,
        "event": "Britain outlaws slavery in most of its colonies, including South Africa, Canada, and the Caribbean Islands."
    },
    {
        "id": 28,
        "year": 1833,
        "event": "On August 12, 1833, the Town of Chicago was incorporated with a population of 350. T"
    },
    {
        "id": 29,
        "year": 1838,
        "event": "Frederick Bailey and Anna Murray are married. The couple moves to New Bedford, Massachusetts and adopt Douglass as the family name. "
    },
    {
        "id": 30,
        "year": 1838,
        "event": "Samuel Morse invents the Morse Code system of dots and dashes for long-distance communication."
    },
    {
        "id": 31,
        "year": 1838,
        "event": "Angelina Grimke speaks to the Massachusetts Legislature in her campaign to end slavery. She is the first woman to address an American legislative body. "
    },
    {
        "id": 32,
        "year": 1838,
        "event": "Edgar Allan Poe publishes his first novel, The Narrative of Arthur Gordon Pym."
    },
    {
        "id": 33,
        "year": 1841,
        "event": "Edgar Allan Poe' publishes his first detective story, Murders in Rue Morgue."
    },
    {
        "id": 34,
        "year": 1841,
        "event": "President William Henry Harrison dies of pneumonia one month after his inauguration. He becomes the first U.S. President to die in office. "
    },
    {
        "id": 35,
        "year": 1841,
        "event": "The U.S. Supreme Court rules that the enslaved Africans who mutinied on the slave ship Amistad were taken illegally. "
    },
    {
        "id": 36,
        "year": 1841,
        "event": "The first wagon train to California leaves Independence, Mississippi. with over 70 adults and children. It takes six months to travel about 1,400 miles (less than eight miles a day)."
    },
    {
        "id": 37,
        "year": 1844,
        "event": "Inventor Elijah McCoy is born. He later patents a lubricating oil cup that allows railroad steam engines to be lubricated without stopping the train."
    },
    {
        "id": 38,
        "year": 1844,
        "event": "North Carolina declares that Blacks are not U.S.citizens. Connecticut passes personal liberty laws and Oregon outlaws slavery."
    },
    {
        "id": 39,
        "year": 1844,
        "event": "The Methodist church splits into northern and southern groups over the issue of slavery. Presbyterian and Baptist churches do the same."
    },
    {
        "id": 40,
        "year": 1844,
        "event": "President James Polk is elected the 11th president of the United States. He leads the nation through the Mexican War and extends its boundaries to the Pacific Ocean."
    },
    {
        "id": 41,
        "year": 1845,
        "event": "The U.S. continues Westward Expansion across the Appalachian Mountains and toward the Pacific Ocean. It creates tensions and wars among Indigenous People, settlers, and immigrants."
    },
    {
        "id": 42,
        "year": 1845,
        "event": "Macon B. Allen and Robert Morris, Jr. open the first African American law firm in the nation. "
    },
    {
        "id": 43,
        "year": 1845,
        "event": "Florida is admitted as the 27th state. Texas joins the union as the 28th state."
    },
    {
        "id": 44,
        "year": 1845,
        "event": "Ireland's \"Potato Famine\" sends Irish immigrants to the United States. "
    },
    {
        "id": 45,
        "year": 1846,
        "event": "The American Missionary Association is founded. This abolitionist society is dedicated to providing educational and political rights to African Americans."
    },
    {
        "id": 46,
        "year": 1846,
        "event": "The Mexican War begins when the United States and Mexico declare war on each other over the Texas/Mexico boundary. The U.S. wins in 1848."
    },
    {
        "id": 47,
        "year": 1846,
        "event": "The California Republic is formed as part of the Bear Flag Revolt. The current-day California state flag is based on the original Bear Flag. "
    },
    {
        "id": 48,
        "year": 1846,
        "event": "The U.S. signs The Oregon Treaty, splitting the Oregon Territory with Great Britain. The border with Canada spans from the Rocky Mountains to the Pacific Ocean."
    },
    {
        "id": 49,
        "year": 1847,
        "event": "The Missouri General Assembly passes a law that bans the education of Black people."
    },
    {
        "id": 50,
        "year": 1847,
        "event": "Congress authorizes the first U.S. postage stamps. Benjamin Franklin is on the 5 cent stamp, and George Washington is on the 10 cent stamp."
    },
    {
        "id": 51,
        "year": 1847,
        "event": "David Jones Peck graduates from Rush Medical School. He is the first African American man to earn a medical degree in the U.S."
    },
    {
        "id": 52,
        "year": 1847,
        "event": "A photographer in St. Louis, Missouri, takes the first known picture of lightning using the daguerreotype process."
    },
    {
        "id": 53,
        "year": 1848,
        "event": "France becomes the first Atlantic empire to outlaw slavery in all of its colonies."
    },
    {
        "id": 54,
        "year": 1848,
        "event": "At the border of Ontario, Canada and New York State, Niagara Falls ices over and stops flowing for 30 hours."
    },
    {
        "id": 55,
        "year": 1848,
        "event": "Boston courts stop five-year old Sarah Roberts from attending the school near her home because she is Black. "
    },
    {
        "id": 56,
        "year": 1848,
        "event": "Frederick Douglass and Anna Murray Douglass shelter Underground Railroad freedom seekers at their home in Rochester, NY."
    },
    {
        "id": 57,
        "year": 1849,
        "event": "Virginia makes it legal to free enslaved people while Kentucky allows interstate slave trade."
    },
    {
        "id": 58,
        "year": 1849,
        "event": "The California Gold Rush marks the beginning of African Americans migrating to the West as hundred of enslaved people work the gold fields. "
    },
    {
        "id": 59,
        "year": 1849,
        "event": "James K. Polk is the first U.S. president to have his picture taken."
    },
    {
        "id": 60,
        "year": 1849,
        "event": "Elizabeth Blackwell becomes the first woman in the U.S. to receive a medical degree."
    },
    {
        "id": 61,
        "year": 1850,
        "event": "The U.S. passes The Fugitive Slave Law saying that all escaped slaves, even in free states, must be returned to owners. Some Blacks and Indigenous People in Texas escape to Mexico."
    },
    {
        "id": 62,
        "year": 1850,
        "event": "The Compromise of 1850 allows California to be free, other states to hold slaves, and bans slave trade in Washington, DC. "
    },
    {
        "id": 63,
        "year": 1850,
        "event": "Virginia reverses its free-slaves law and forces formerly enslaved people to leave the state within a year. Virginia's neighbor, Maryland, allows interstate slave trade."
    },
    {
        "id": 64,
        "year": 1850,
        "event": "The Californian cities of Los Angeles and San Francisco are incorporated. "
    },
    {
        "id": 65,
        "year": 1851,
        "event": "Shadrack Minkins, the first person captured by the Fugitive Slave Law, is rescued from a Boston courtroom by Black abolitionists. They help him get to Canada."
    },
    {
        "id": 66,
        "year": 1851,
        "event": "At the Ohio Women's Rights Convention, Sojourner Truth gives a speech titled, \"Ain't I a Woman?\" She states that women are as smart and as strong as men."
    },
    {
        "id": 67,
        "year": 1851,
        "event": "The Miner Normal School in Washington , DC, is started for teaching skills to Black women. It later becomes the University of the District of Columbia (UDC)."
    },
    {
        "id": 68,
        "year": 1851,
        "event": "The U.S. joins 89 nations and colonies at the World's Fair in London, England. It is the first international exhibition in history."
    },
    {
        "id": 69,
        "year": 1856,
        "event": "Wilberforce University in Ohio opens as the first college owned and operated by African Americans."
    },
    {
        "id": 70,
        "year": 1858,
        "event": "Boston abolitionists create Crispus Attucks Day to honor him. Attucks was a Black American who was the first man killed in the American Revolution."
    },
    {
        "id": 71,
        "year": 1852,
        "event": "President-elect Franklin Pierce says that he is anti-slavery, but believes that the South has the right to take slavery into U.S. territories."
    },
    {
        "id": 72,
        "year": 1852,
        "event": "British scientists name Peak XV in the Himalayas as the world's tallest mountain. They later change the name to Mount Everest to honor Colonel George Everest, a British leader in India."
    },
    {
        "id": 73,
        "year": 1852,
        "event": "Elisha Graves Otis improves the early elevator. His new system makes skyscrapers possible."
    },
    {
        "id": 74,
        "year": 1852,
        "event": "A cholera pandemic starts. It lasts seven years and devastates Asia, Europe, North America, and Africa."
    },
    {
        "id": 75,
        "year": 1855,
        "event": "The Wisconsin Supreme Court rules that the Fugitive Slave Law is unconstitutional and is not legal."
    },
    {
        "id": 76,
        "year": 1855,
        "event": "Massachusetts issues the first state school vaccine mandate in the United States for smallpox."
    },
    {
        "id": 77,
        "year": 1855,
        "event": "Personal liberty laws are passed or strengthened in Connecticut, Massachusetts, Mississippi, and Rhode Island. Georgia and Tennessee allow interstate slave trade."
    },
    {
        "id": 78,
        "year": 1855,
        "event": "The first railroad train crosses the Mississippi River on a bridge from Illinois to Iowa."
    },
    {
        "id": 79,
        "year": 1857,
        "event": "Dred Scot and his family are freed by their owner, Henry Taylor Blow, three months after the U.S. Supreme Court ruled against Scot."
    },
    {
        "id": 80,
        "year": 1857,
        "event": "New Hampshire and Vermont allow Black Americans to enlist in the military. Ohio and Wisconsin pass personal liberty laws."
    },
    {
        "id": 81,
        "year": 1857,
        "event": "The Panic of 1857 begins, setting off one of the most severe economic crises in U.S. history."
    },
    {
        "id": 82,
        "year": 1857,
        "event": "National Association of Baseball Players founded in New York. "
    },
    {
        "id": 83,
        "year": 1859,
        "event": "Harriet Tubman makes one of her last rescue trips to save friends and family. She rescues her niece, Margaret, later believed to be Tubman's daughter."
    },
    {
        "id": 84,
        "year": 1859,
        "event": "A geomagnetic storm causes the Aurora Borealis to shine so brightly that it is seen clearly over parts of the United States, Europe and Japan. "
    },
    {
        "id": 85,
        "year": 1859,
        "event": "The Clotilde ship lands in Alabama, with enslaved Africans who were captured illegally. It is the last known slave ship to land in the U.S."
    },
    {
        "id": 86,
        "year": 1859,
        "event": "Tubman moves to her Auburn, NY home bought from U.S. Senator William Seward. He was a powerful abolitionist and Tubman's loyal friend."
    },
    {
        "id": 87,
        "year": 1860,
        "event": "The Census of 1860 shows the population of enslaved people is nearly four million. This makes a ratio of free to enslaved Americans 7:1."
    },
    {
        "id": 88,
        "year": 1860,
        "event": "The Pony Express starts carrying mail between Missouri and California. It lasts 18 months until the telegraph makes it unnecessary."
    },
    {
        "id": 89,
        "year": 1860,
        "event": "Belgian inventor Etienne Lenoir builds an internal combustion engine that replaces the boiler to move a vehicle without horse. "
    },
    {
        "id": 90,
        "year": 1860,
        "event": "South Carolina is the first state to secede from the Union after the election of Abraham Lincoln. "
    },
    {
        "id": 91,
        "year": 1861,
        "event": "Ten pro-slavery southern states secede from the Union and join South Carolina to form the Confederate States of America. The U.S. Civil War begins. "
    },
    {
        "id": 92,
        "year": 1861,
        "event": "James Stone hides his racial identity and enlists in the Union Army in Ohio. He is the first African American soldier to fight in the U.S. Civil War. "
    },
    {
        "id": 93,
        "year": 1861,
        "event": "The Confiscation Act of 1861 allows the Union Army to capture, keep, and free enslaved people from the Southern states."
    },
    {
        "id": 94,
        "year": 1861,
        "event": "The Nightingale Training School opens in England. It is the first school for training nurses; it begins modern nursing as a respected profession.  "
    },
    {
        "id": 95,
        "year": 1863,
        "event": "Frederick Douglass meets with Abraham Lincoln to successfully negotiate equal pay for newly-formed Black military units."
    },
    {
        "id": 96,
        "year": 1863,
        "event": "The first homesteader files a claim in Nebraska. The Homestead Act gives up to 160 acres of free land to heads of families or anyone over age 21. "
    },
    {
        "id": 97,
        "year": 1863,
        "event": "Abraham Lincoln signs the National Currency Act and establishes a single, national U.S. currency."
    },
    {
        "id": 98,
        "year": 1863,
        "event": "The Fifty-Fourth Massachusetts Volunteers, an all-Black unit of the Union army, charges Fort Wagner in Charleston, South Carolina. "
    },
    {
        "id": 99,
        "year": 1864,
        "event": "Entrepreneur Madam CJ Walker is born, and she later develops a line of beauty products. "
    },
    {
        "id": 100,
        "year": 1864,
        "event": "Wayland Seminary for Black students is founded. It later joins the Richmond Institute to become Virginia Union University, an early member of Historically Black Colleges and Universities (HBCU)."
    },
    {
        "id": 101,
        "year": 1864,
        "event": "Scientist George Washington Carver is born, and he later discovers hundreds of uses for the peanut."
    },
    {
        "id": 102,
        "year": 1864,
        "event": "Congress repeals the Fugitive Slave Act of 1850 and the the Fugitive Slave Act of 1793."
    },
    {
        "id": 103,
        "year": 1865,
        "event": "General Robert E. Lee of the Confederacy surrenders to the Union. The American Civil War is over."
    },
    {
        "id": 104,
        "year": 1865,
        "event": "President Abraham Lincoln is assassinated at the Ford's Theatre in Washington, D.C."
    },
    {
        "id": 105,
        "year": 1865,
        "event": "Maryland doctor Samuel Mudd is imprisoned for helping John Wilkes Booth after he shot Lincoln. "
    },
    {
        "id": 106,
        "year": 1865,
        "event": "Congress establishes the Freedmen's Bureau to provide health care, education, food, clothing, land, and technical assistance to emancipated black Americans."
    },
    {
        "id": 107,
        "year": 1866,
        "event": "Frederick Douglass leads a black delegation to met with President Andrew Johnson in support of black suffrage. President Johnson opposes the delegation. "
    },
    {
        "id": 108,
        "year": 1866,
        "event": "The Buffalo Soldiers are formed to protect the western frontier beyond the Mississippi River. The soldiers are part of the U.S. Peacetime Army and among the first national park rangers. "
    },
    {
        "id": 109,
        "year": 1866,
        "event": "HBCUs expand with the addition of Brown Theological Seminary in Florida, Fisk University in Tennessee, Lincoln Institute in Missouri, and Rust College in Mississippi."
    },
    {
        "id": 110,
        "year": 1866,
        "event": "Matthew Henson, future Arctic explorer, is born in Maryland to parents who are free sharecroppers. He becomes the first person to reach the geographic North Pole."
    },
    {
        "id": 111,
        "year": 1868,
        "event": "The Georgia State Legislature votes to expel its Black elected officials. It takes an appeal to President Ulysses Grant to readmit them in 1869."
    },
    {
        "id": 112,
        "year": 1868,
        "event": "CH Gould in England gets a patent for the stapler, and American Christopher Sholes patents the typewriter."
    },
    {
        "id": 113,
        "year": 1868,
        "event": "George Westinghouse gets the first of many patents for railroad trains that will connect the country. The patents help to change the world of transportation."
    },
    {
        "id": 114,
        "year": 1868,
        "event": "Colonel George Custer leads the 7th U.S. Cavalry in an attack on the Cheyenne Tribe near the Washita River in Oklahoma. "
    },
    {
        "id": 115,
        "year": 1869,
        "event": "Elizabeth Cady Stanton, a famous suffragist, is the first woman to speak before the U.S. Congress."
    },
    {
        "id": 116,
        "year": 1869,
        "event": "Over 3,000 Freedmen's Bureau schools serve more than 150,00 Black students in the South."
    },
    {
        "id": 117,
        "year": 1869,
        "event": "The nation's east and west coasts are connected by the Transcontinental Railroad. Over 15,000 Chinese workers play an essential role and work under brutal conditions to build the railroad. "
    },
    {
        "id": 118,
        "year": 1869,
        "event": "The first cross-country railroad freight train travels for 16 days from Boston, MA to San Francisco, CA."
    },
    {
        "id": 119,
        "year": 1870,
        "event": "President Grant suggests annexing (taking) the small Caribbean nation of Santo Domingo to give freed Blacks a place to live. U.S. Senator Charles Sumner stops the idea."
    },
    {
        "id": 120,
        "year": 1870,
        "event": "Seceded states come back to the Union, one by one, until the Confederacy is gone."
    },
    {
        "id": 121,
        "year": 1870,
        "event": "Hiram Rhodes Revels from Mississippi is the first African American to serve in the U.S. Congress. "
    },
    {
        "id": 122,
        "year": 1870,
        "event": "President Ulysses Grant signs a resolution to set up a national weather warning service. The National Weather Service is the official weather bureau of the United States. "
    },
    {
        "id": 123,
        "year": 1877,
        "event": "Henry Flipper is the first African American to graduate from the United States Military Academy at West Point, NY. He becomes the first Black leader of the Buffalo Soldiers."
    },
    {
        "id": 124,
        "year": 1877,
        "event": "The new Secretary of the Interior, Carl Schurz, starts a movement for a national park system and national forest service. "
    },
    {
        "id": 125,
        "year": 1877,
        "event": "The Compromise of 1877 resolves the disputed presidential election of 1876. Rutherford B. Hayes becomes president in exchange for the end of Reconstruction in the South. "
    },
    {
        "id": 126,
        "year": 1877,
        "event": "Indian Wars continue with the Nez Perce in Idaho who resist going to a reservation, but end for the Sioux Indians in Nebraska who surrender because of cold and starvation."
    },
    {
        "id": 127,
        "year": 1881,
        "event": "The Tuskegee Institute is founded by Booker T. Washington for Black students under a charter from the Alabama legislature. The school's purpose is to train teachers in Alabama. "
    },
    {
        "id": 128,
        "year": 1881,
        "event": "President James Garfield is shot in a Washington, DC train station by an angry lawyer. Garfield dies 79 days later from an infection of his wound. "
    },
    {
        "id": 129,
        "year": 1881,
        "event": "Chief Sitting Bull and other fugitives from the Sioux reservation surrender to soldiers in Montana."
    },
    {
        "id": 130,
        "year": 1881,
        "event": "The first international telephone call occurs between Calais, Maine in the U.S. and St. Stephens in New Brunswick, Canada The towns are less than a mile apart."
    },
    {
        "id": 131,
        "year": 1886,
        "event": "President Grover Cleveland dedicates the Statue of Liberty, a gift from France, in New York Harbor."
    },
    {
        "id": 132,
        "year": 1886,
        "event": "The Indian Wars with the U.S. Army finally end when Geronimo and the Apaches surrender at an Army fort in Arizona."
    },
    {
        "id": 133,
        "year": 1886,
        "event": "In Georgia, pharmacist, Dr. John Pemberton, invents and starts selling Coca-Cola."
    },
    {
        "id": 134,
        "year": 1886,
        "event": "The first major earthquake is recorded in the eastern US, at Charleston, South Carolina. 110 deaths are recorded. "
    },
    {
        "id": 135,
        "year": 1889,
        "event": "President Cleveland signs a law to protects historic sites in the U.S. The first site protected is the prehistoric Casa Grande ruin in Arizona."
    },
    {
        "id": 136,
        "year": 1889,
        "event": "Oklahoma Territory opens and sees the first of five land rushes. 50,000 settlers race and fight for their own 160 acres of free land. "
    },
    {
        "id": 137,
        "year": 1889,
        "event": "The first long-distance electric line runs 14 miles between two cities in Oregon."
    },
    {
        "id": 138,
        "year": 1889,
        "event": "The Little Conemaugh River in Pennsylvania causes the Johnstown Flood when heavy rains break the dam 14 miles away. Water destroys the town and kills over 2,200 people. "
    },
    {
        "id": 139,
        "year": 1895,
        "event": "Booker T. Washington delivers the Atlanta Compromise speech in Georgia., He encourages Black Americans to focus on manual labor and technical training to improve job skills. "
    },
    {
        "id": 140,
        "year": 1895,
        "event": "George Selden gets the first U.S. automobile patent for an engine he invented."
    },
    {
        "id": 141,
        "year": 1895,
        "event": "W.E.B. Du Bois becomes the first African American to earn a Ph.D. from Harvard University."
    },
    {
        "id": 142,
        "year": 1895,
        "event": "Norwegian scientist Fritjof Nansen and his team almost reach the North Pole by ship, dogsled and snowshoes, getting closer than any other expedition. He wins the Nobel Peace Prize in 1922."
    },
    {
        "id": 143,
        "year": 1896,
        "event": "The U.S. Supreme Court rules in Plessy v Ferguson that \"separate but equal\" is legal. The ruling approves racial segregation."
    },
    {
        "id": 144,
        "year": 1896,
        "event": "Gold is discovered in the Yukon Territory of Canada. The discovery is the start of the Klondike gold rush between Washington State and Alaska. "
    },
    {
        "id": 145,
        "year": 1896,
        "event": "The United States is one of 13 nations to attend the Modern Olympics in Greece, with male athletes only. The previous games were held in about the year 400."
    },
    {
        "id": 146,
        "year": 1896,
        "event": "German scientist Wilhelm Rontgen announces his discovery of X-rays, first called Rontgen Rays. Five years later he wins the Nobel Prize in Physics."
    },
    {
        "id": 147,
        "year": 1898,
        "event": "Sanford Dole, an American sugar planter, overthrows Queen Lili'uokalani of the independent nation of Hawaiʻi. Hawaiʻi becomes part of the United States and Dole becomes governor."
    },
    {
        "id": 148,
        "year": 1898,
        "event": "The Spanish-American War ends with Spain giving freedom to Cuba. The United States gets the Spanish islands of Philippines, Guam, and Puerto Rico."
    },
    {
        "id": 149,
        "year": 1898,
        "event": "Ida B. Wells organizes the National Afro-American Council, the first national civil rights organization in the United States. "
    },
    {
        "id": 150,
        "year": 1898,
        "event": "Voter suppression was legally upheld in Louisiana and Mississippi during the Jim Crow era. These laws restricted the right to vote for Black Americans. "
    },
    {
        "id": 151,
        "year": 1908,
        "event": "Alpha Kappa Alpha Sorority, Inc. is founded by, and for, Black college women. It is chartered at Howard University in Washington, DC."
    },
    {
        "id": 152,
        "year": 1908,
        "event": "President Theodore Roosevelt adds four sites to the preserved lands of the National Park System."
    },
    {
        "id": 153,
        "year": 1908,
        "event": "The Hudson & Manhattan Railroad begins service. The first train travels almost 11 minutes from New York City to Hoboken, NJ under the Hudson River. "
    },
    {
        "id": 154,
        "year": 1908,
        "event": "Thurgood Marshall is born in Baltimore, MD. He later becomes a lawyer for the NAACP in the famous U.S. Supreme Court case, Brown v. Board of Education (1954). "
    },
    {
        "id": 155,
        "year": 1913,
        "event": "Grand Central Terminal, the world's largest railroad station, opens in New York City. It is a popular attraction because of its size and beautiful design."
    },
    {
        "id": 156,
        "year": 1913,
        "event": "Suffragists march through Washington, DC in the first political march in U.S. history. Black women suffragists take part but are not on the official program. "
    },
    {
        "id": 157,
        "year": 1913,
        "event": "Jubilee Year, the 50th anniversary of the Emancipation Proclamation, is celebrated throughout the year."
    },
    {
        "id": 158,
        "year": 1913,
        "event": "The first moving assembly line opens at the Ford Motor Company factory in Highland Park, IL."
    },
    {
        "id": 159,
        "year": "1910-1919",
        "event": "1916 Marcus Garvey arrives in New York from Jamaica to expand his Black nationalist movement, promote racial pride and an independent Black nation in Africa. He is criticized by Black and white leaders."
    },
    {
        "id": 160,
        "year": "1910-1919",
        "event": "1916 The Great Migration begins when more than six million African Americans relocate from the rural South to metropolitan cities in the North, Midwest, and West in search of a better quality of life."
    },
    {
        "id": 161,
        "year": "1910-1919",
        "event": "1918 World War I ends when Germany surrenders. The Dyer Anti-lynching bill is introduced to establish lynching as a federal crime. The Spanish flu pandemic kills 20 million people around the world."
    },
    {
        "id": 162,
        "year": "1910-1919",
        "event": "The first Pan-African Congress convenes under the leadership of W.E.B. Dubois to unite the black global diaspora and discuss the international problem of racism."
    },
    {
        "id": 163,
        "year": "1920-1929",
        "event": "The Harlem Renaissance begins. This period of history showcases creativity within the African American community in the areas of art, music and literature."
    },
    {
        "id": 164,
        "year": "1920-1929",
        "event": "1924 The U.S. wins four medals against 15 other countries in France at the first Winter Olympics. Women compete only in figure skating."
    },
    {
        "id": 165,
        "year": "1920-1929",
        "event": "1927 Charles Lindbergh flies his plane, The Spirit of St. Louis, from New York to Paris on the first non-stop flight across the Atlantic Ocean."
    },
    {
        "id": 166,
        "year": "1920-1929",
        "event": "1929 The U.S. economy fails when businesses and banks lose most of their money. It is the beginning of The Great Depression. "
    },
    {
        "id": 167,
        "year": "1930-1939",
        "event": "The Great Depression is a period of severe economic crisis that lasts throughout the 1930s. Factories close down, many people are unemployed, stock prices fall dramtically, and thousands of banks fail. The impact is felt worldwide. "
    },
    {
        "id": 168,
        "year": "1930-1939",
        "event": "1930 The Dust Bowl is an environmental catastrophe that causes drought and destroys farmlands in the U.S. Great Plain through 1936. "
    },
    {
        "id": 169,
        "year": "1930-1939",
        "event": "1936 Jesse Owens competes in the Berlin Summer Olympics. He is the first American track and field athlete to win four gold medals at a single Olympic Games."
    },
    {
        "id": 170,
        "year": "1930-1939",
        "event": "1939 Hattie McDaniel is the first African American to win a movie Oscar for her role in Gone with the Wind. Her parents were formerly enslaved, and her father was a Union soldier in the Civil War."
    },
    {
        "id": 171,
        "year": "1940-1949",
        "event": "1941  Dorie Miller, a Black sailor stationed in Hawaii, becomes a World War II hero after an attack on Pearl Harbor. He carries wounded men to safety and mans a machine gun post to defend against Japanese bombers. "
    },
    {
        "id": 172,
        "year": "1940-1949",
        "event": "1945 World War II ends when Japan surrenders after U.S. atomic bombs destroy two Japanese cities. Germany surrenders after Allied troops invade beaches in German-occupied France."
    },
    {
        "id": 173,
        "year": "1940-1949",
        "event": "1947 Ralph Bunche becomes the first U.S. African American to write an international peace treaty. Jackie Robinson is the first Black professional baseball player."
    },
    {
        "id": 174,
        "year": "1940-1949",
        "event": "1949 The Space Age begins when President Harry Truman signs a law to build a rocket test range at Cape Canaveral, Florida. "
    },
    {
        "id": 175,
        "year": "1950",
        "event": "1955 Claudette Colvin and Rosa Parks are arrested for refusing to give up their seats on a segregated bus. Their activism starts the successful movement to desegregate buses."
    },
    {
        "id": 176,
        "year": "1950-1959",
        "event": "1957 President Dwight Eisenhower orders federal troops to protect Black American students against racial violence in Arkansas. The \"Little Rock Nine\" enter Central High School amid protests and resistance to school desegregation. "
    },
    {
        "id": 177,
        "year": "1950-1959",
        "event": "1958 The National Aeronautics and Space Administration (NASA) begins operations for exploring space. "
    },
    {
        "id": 178,
        "year": "1950-1959",
        "event": "1959 Alaska becomes the 49th US state, and Hawai'i becomes the 50th US state later in the year. "
    },
    {
        "id": 179,
        "year": "1960-1969",
        "event": "1962  The National Park Service buys Frederick Douglass's house in Washington, DC. It repairs and preserves the site for the public. "
    },
    {
        "id": 180,
        "year": "1960-1969",
        "event": "1963  Civil rights leader Rev. Martin Luther King, Jr. leads the March on Washington protest. President John F. Kennedy is assassinated in Dallas, TX. "
    },
    {
        "id": 181,
        "year": "1960-1969",
        "event": "1964 The landmark Civil Rights Act of 1964  bans discrimination on the basis of race, color, religion, sex, and national origin. "
    },
    {
        "id": 182,
        "year": "1960-1969",
        "event": "1968  Rev. Martin Luther King, Jr. and presidential hopeful Robert Kennedy, are assassinated. Students at San Francisco University lead a five-month protest in demand for the first college of ethnic studies. "
    },
    {
        "id": 183,
        "year": "1970-1979",
        "event": "1974  Republican President Richard Nixon is the first president to resign for spying on his enemies in the Democratic Party. His staff conspirators go to jail."
    },
    {
        "id": 184,
        "year": "1970-1979",
        "event": "1979  President Jimmy Carter says that he wants Dr. Martin Luther King Jr.'s birthday to be a national holiday. The first one is in 1986."
    },
    {
        "id": 185,
        "year": "1970-1979",
        "event": "1975  The War in Vietnam ends. It is the first war with integrated U.S. troops. Almost half of the U.S. soldiers and sailors in Vietnam are African American."
    },
    {
        "id": 186,
        "year": "1970-1979",
        "event": "1976  In a home garage in California, Steve Wozniak and Steve Jobs make the first desktop computer. They change technology forever when they launch Apple Computer, Inc."
    },
    {
        "id": 187,
        "year": "1980-1989",
        "event": "1980 Mount St. Helens, a volcano in Washington State, erupts. People 300 miles away hear it, as It melts soil and boils rivers resulting in flooding and the destruction of the forest and hundreds of homes. "
    },
    {
        "id": 188,
        "year": "1980-1989",
        "event": "1983  Guion Buford, a veteran and pilot, becomes the first African American to travel to space. Physician Mae Jemison follows as the first Black woman astronaut in 1992."
    },
    {
        "id": 189,
        "year": "1980-1989",
        "event": "1987  The first successful surgery to separate conjoined twins takes place at  The Johns Hopkins Hospital in Maryland. The neurosurgeon is African American, Dr.Ben Carson. "
    },
    {
        "id": 190,
        "year": "1980-1989",
        "event": "1989  Veteran and lawyer, Douglas Wilder, becomes the first African American governor of Virginia, or any other state, since the end of the Civil War. "
    },
    {
        "id": 191,
        "year": "1990-1999",
        "event": "1991  South Africa ends Apartheid, the longtime practice of forced legal racial segregation. Three years later, the anti-Apartheid leader Nelson Mandela becomes president of the country."
    },
    {
        "id": 192,
        "year": "1990-1999",
        "event": "1991  Tim Berners-Lee, a British physicist, designs and launches the World Wide Web as a free information management system. It soon explodes from one website to millions of sites."
    },
    {
        "id": 193,
        "year": "1990-1999",
        "event": "1998 The USA Women's Ice Hockey Team beats Canada and wins the first Olympic Gold medal"
    },
    {
        "id": 194,
        "year": "1990-1999",
        "event": "1996  The first foldable cell phone is for sale at $1,000. It has a small screen, pull-out antenna, no camera, and the first \"silent\" setting for incoming calls."
    },
    {
        "id": 195,
        "year": "2000-2009",
        "event": "2000 General Colin Powell becomes the first African American U.S. Secretary of State, followed in 2005 by the first Black woman Secretary of State, Condoleeza Rice. "
    },
    {
        "id": 196,
        "year": "2000-2009",
        "event": "2003 U.S. Space Shuttle Challenger falls apart as it comes back to Earth, killing all seven astronauts. "
    },
    {
        "id": 197,
        "year": "2000-2009",
        "event": "2005  Klan leader Edward Ray Killen is arrested for murder, 40 years after he arranged the killing of three Civil Rights workers in Mississippi. He dies in prison in 2018."
    },
    {
        "id": 198,
        "year": "2000-2009",
        "event": "2009  The \"Miracle on the Hudson\" happens when birds crash into the engine of a jet carrying 155 people. The pilot saves everyone by using the Hudson River as a runway."
    },
    {
        "id": 199,
        "year": "2010-2019",
        "event": "2013 The national Black Lives Matter movement begins after the acquittal of George Zimmerman in the shooting death of Trayvon Martin. Global demonstrations protest police brutality and systematic racism impacting the Black community."
    },
    {
        "id": 200,
        "year": "2010-2019",
        "event": "2016 The Standing Rock Sioux Tribe protests the construction of the Dakota Access Pipeline in North Dakota in an effort to protect Indigenous rights, sacred sites, and significant artifacts on the land. "
    },
    {
        "id": 201,
        "year": "2010-2019",
        "event": "2017 The Women's March in Washington, D.C. is one of the largest single-day demonstrations in US history. Millions of women across the country and worldwide join in sister marches to support the fight for women's rights, gender equality, social and racial justice, and civil rights. "
    },
    {
        "id": 202,
        "year": "2010-2019",
        "event": "2019 President Donald Trump becomes the third president in US history to be impeached. Impeachment is a two-stage process to remove a president from office. In 2020, he was acquitted of the charges. "
    },
    {
        "id": 203,
        "year": 2020,
        "event": "The coronavirus outbreak becomes a global pandemic forcing countries worldwide to shut down their borders; people must isolate and most public and private businesses and services close. By June 2022, the World Health Organization (WHO) confirms over 6.3 million deaths. "
    },
    {
        "id": 204,
        "year": 2020,
        "event": "George Floyd was arrested by police in Minneapolis, MN. Video footage showed an officer kneeling on his neck, and Floyd was unable to breathe. His death sparked global protests against systemic racial injustice and police violence. "
    },
    {
        "id": 205,
        "year": 2020,
        "event": "The COVID-19 pandemic shuts down the Summer Olympics and other sporting events worldwide. The Summer Olympics in Tokyo, Japan is postponed, and the Wimbledon tennis championship in England is canceled."
    },
    {
        "id": 206,
        "year": 2020,
        "event": "Kamala Harris is elected as the 49th Vice President of the United States. She is the first woman to serve in the position, as well as the first African American and South Asian vice president."
    },
    {
        "id": 207,
        "year": 2021,
        "event": "Demonstrators storm the US Capitol to stop lawmakers from certifying the 2020 presidential election results. More than 600 people were charged in the insurrection attempt to disrupt the peaceful transfer of power. "
    },
    {
        "id": 208,
        "year": 2021,
        "event": "The NASA rover Perseverance lands on Mars after traveling for seven months and 292.5 million miles from Earth. The rover searches for evidence of life on planet Mars."
    },
    {
        "id": 209,
        "year": 2021,
        "event": "President Joe Biden signs legislation officially establishing June 19 as Juneteenth National Independence Day, a federal holiday commemorating the end of slavery in the United States. "
    },
    {
        "id": 210,
        "year": 2021,
        "event": "Broadway theaters in New York City reopen for the first time since March 2020. Audience members are required to follow pandemic precautions including proof of vaccination and face masks."
    }
]
}

export default miscEvents;